import homeProgressNavbar from 'url:../../../assets/images/home-workout-navbar.webp';
import homeProgress0 from 'url:../../../assets/images/home-progress-0.webp';
import homeProgress1 from 'url:../../../assets/images/home-progress-1.webp';
import homeProgress2 from 'url:../../../assets/images/home-progress-2.webp';
import homeProgress3 from 'url:../../../assets/images/home-progress-3.webp';
import homeProgress4 from 'url:../../../assets/images/home-progress-4.webp';
import homeProgress5 from 'url:../../../assets/images/home-progress-5.webp';
import homeProgress6 from 'url:../../../assets/images/home-progress-6.webp';
import homeProgress7 from 'url:../../../assets/images/home-progress-7.webp';
import homeProgress8 from 'url:../../../assets/images/home-progress-8.webp';
import homeProgress9 from 'url:../../../assets/images/home-progress-9.webp';
import homeProgress10 from 'url:../../../assets/images/home-progress-10.webp';
import homeProgress11 from 'url:../../../assets/images/home-progress-11.webp';

export const homeWorkoutImages = {
  homeProgressNavbar,
  homeProgress0,
  homeProgress1,
  homeProgress2,
  homeProgress3,
  homeProgress4,
  homeProgress5,
  homeProgress6,
  homeProgress7,
  homeProgress8,
  homeProgress9,
  homeProgress10,
  homeProgress11,
} as const;

export const homeWorkoutImageList = Object.values(homeWorkoutImages);
